import { useCallback, useEffect, useState } from "react";
import {
  clearAuthSession,
  getAuthUser,
  isAdminUser,
  isLoggedIn,
} from "../util/auth";

export const useAuth = () => {
  const [authState, setAuthState] = useState(() => ({
    isLoggedIn: isLoggedIn(),
    user: getAuthUser(),
    isAdmin: isAdminUser(),
  }));

  const refreshAuth = useCallback(() => {
    setAuthState({
      isLoggedIn: isLoggedIn(),
      user: getAuthUser(),
      isAdmin: isAdminUser(),
    });
  }, []);

  useEffect(() => {
    const handleAuthChange = () => refreshAuth();
    window.addEventListener("auth-changed", handleAuthChange);
    window.addEventListener("storage", handleAuthChange);

    return () => {
      window.removeEventListener("auth-changed", handleAuthChange);
      window.removeEventListener("storage", handleAuthChange);
    };
  }, [refreshAuth]);

  const logout = () => {
    clearAuthSession();
    refreshAuth();
  };

  return {
    ...authState,
    logout,
    refreshAuth,
  };
};
